import React, { useState, useEffect } from 'react';
import { 
  Box, 
  TextField, 
  IconButton, 
  InputAdornment,
  Paper,
  Tooltip,
  Button
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import LoginIcon from '@mui/icons-material/Login';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const ChatInput = ({ onSendMessage, isDisabled, selectedQuestion, onQuestionUsed }) => {
  const [message, setMessage] = useState('');
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  
  // Set message when selectedQuestion changes
  useEffect(() => {
    if (selectedQuestion) {
      setMessage(selectedQuestion);
      // Notify parent that the question has been used
      if (onQuestionUsed) {
        onQuestionUsed();
      }
    }
  }, [selectedQuestion, onQuestionUsed]);

  const getPlaceholderText = () => {
    if (isDisabled) {
      return "Reconectando al servidor...";
    }
    if (!currentUser) {
      return "Inicia sesión para enviar mensajes";
    }
    return "Escribe tu mensaje aquí...";
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim() && !isDisabled && currentUser) {
      onSendMessage(message);
      setMessage('');
    }
  };
  
  const handleLogin = () => {
    navigate('/login');
  };

  return (
    <Paper
      component="form"
      onSubmit={handleSubmit}
      elevation={0}
      sx={{
        display: 'flex',
        alignItems: 'center',
        p: 1,
        borderRadius: 3,
        backgroundColor: isDisabled ? 'grey.100' : 'grey.50',
        border: '1px solid',
        borderColor: isDisabled ? 'grey.300' : 'grey.200',
      }}
    >
      {!currentUser ? (
        // Login button for unauthenticated users
        <Button
          variant="contained"
          color="primary"
          startIcon={<LoginIcon />}
          onClick={handleLogin}
          fullWidth
          sx={{ py: 1, borderRadius: 2 }}
        >
          Iniciar sesión para usar el chat
        </Button>
      ) : (
        // Chat input for authenticated users
        <TextField
          fullWidth
          placeholder={getPlaceholderText()}
          variant="standard"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          disabled={isDisabled}
          slotProps={{
            input: {
              // disables underline for the input
              disableUnderline: true,
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip title={isDisabled ? "Reconectando al servidor" : ""}>
                    <span>
                      <IconButton
                        color="primary"
                        type="submit"
                        aria-label="send message"
                        sx={{
                          bgcolor: message.trim() && !isDisabled ? 'primary.main' : 'grey.300',
                          color: 'white',
                          '&:hover': {
                            bgcolor: message.trim() && !isDisabled ? 'primary.dark' : 'grey.400',
                          },
                          width: 40,
                          height: 40,
                        }}
                        disabled={!message.trim() || isDisabled}
                      >
                        <SendIcon fontSize="small" />
                      </IconButton>
                    </span>
                  </Tooltip>
                </InputAdornment>
              ),
            },
          }}
          sx={{
            px: 2,
            py: 1,
            '& .MuiInputBase-input': {
              fontSize: '1rem', // Ajusta este valor según necesites
            },
          }}
        />
      )}
    </Paper>
  );
};

export default ChatInput;